<div class="wrapper-list">
    <div class="section-title">
      <div class="row">
        <div class="col">
          <div class="d-flex align-items-center">
            <a routerLink="/dashboard/faq" class="btn btn-back" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </a>
            <div class="title" [attr.data-parent]="'Help Center' | translate">{{ "Knowledgebase" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  <div class="section-main container-fluid">
    <div class="row">
      <div class="col-xl-12 xl-12">
        <div class="row">
          <div class="col-xl-6">
            <div class="card p-20">
              <div class="blog-box blog-list row">
                <div class="col-sm-5 m-auto"><img class="img-fluid sm-100-w" src="assets/sample-img1.jpg" alt=""></div>
                <div class="col-sm-7">
                  <div class="blog-details">
                    <div class="blog-date digits"><span>19</span> {{ "October" | translate }} 2022</div>
                    <!-- <h6>Java Language </h6> -->
                    <a routerLink="/dashboard/detail-knowledge-base" (click)="checkcontent('article1')" style="color: #2152ff;">{{ "What is eStore? - The Complete Guide to Your Shopping Experience." | translate }}</a>
                    <div class="blog-bottom-content">
                      <ul class="blog-social">
                        <li>{{ "By: Admin" | translate }}</li>
                        <li>{{ "General" | translate }}</li>
                        <li class="digits"><i class="fi fi-rr-clock-nine"></i>1 {{ "min" | translate }}</li>
                      </ul>
                      <hr>
                      <p class="mt-0">{{ "eStore is an e-commerce platform by Wellous that specializes in acquiring, redeeming, and selling products digitally..." | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  `        </div>
          <div class="col-xl-6">
            <div class="card p-20">
              <div class="blog-box blog-list row">
                <div class="col-sm-5 m-auto"><img class="img-fluid sm-100-w" src="assets/sample-img3.jpg" alt=""></div>
                <div class="col-sm-7">
                  <div class="blog-details">
                    <div class="blog-date digits"><span>03</span> {{ "November" | translate }} 2022</div>
                    <!-- <h6>Java Language </h6> -->
                    <a routerLink="/dashboard/detail-knowledge-base" (click)="checkcontent('article2')" style="color: #2152ff;">{{ "Setting up a Cash on Delivery (COD) Payment Method." | translate }}</a>
                    <div class="blog-bottom-content">
                      <ul class="blog-social">
                        <li>{{ "By: Admin" | translate }}</li>
                        <li>{{ "Payment" | translate }}</li>
                        <li class="digits"><i class="fi fi-rr-clock-nine"></i>15 {{ "min" | translate }}</li>
                      </ul>
                      <hr>
                      <p class="mt-0">{{ "In addition to online payments, you can accept payments outside of your store..." | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6">
            <div class="card p-20">
              <div class="blog-box blog-list row">
                <div class="col-sm-5 m-auto"><img class="img-fluid sm-100-w" src="assets/sample-img5.png" alt=""></div>
                <div class="col-sm-7">
                  <div class="blog-details">
                    <div class="blog-date digits"><span>17</span> {{ "February" | translate }} 2023</div>
                    <!-- <h6>Java Language </h6> -->
                    <a routerLink="/dashboard/detail-knowledge-base" (click)="checkcontent('article3')" style="color: #2152ff;">{{ "The Digital Marketing Channels for eCommerce." | translate }}</a>
                    <div class="blog-bottom-content">
                      <ul class="blog-social">
                        <li>{{ "By: Admin" | translate }}</li>
                        <li>{{ "General" | translate }}</li>
                        <li class="digits"><i class="fi fi-rr-clock-nine"></i>15 {{ "min" | translate }}</li>
                      </ul>
                      <hr>
                      <p class="mt-0">{{ "One thing that all successful eCommerce stores have in common is how they incorporate all of these channels into their marketing strategy..." | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6">
            <div class="card p-20">
              <div class="blog-box blog-list row">
                <div class="col-sm-5 m-auto"><img class="img-fluid sm-100-w" src="assets/sample-img6.png" alt=""></div>
                <div class="col-sm-7">
                  <div class="blog-details">
                    <div class="blog-date digits"><span>17</span> {{ "February" | translate }} 2023</div>
                    <!-- <h6>Java Language </h6> -->
                    <a routerLink="/dashboard/detail-knowledge-base" (click)="checkcontent('article4')" style="color: #2152ff;">{{ "Express Checkout." | translate }}</a>
                    <div class="blog-bottom-content">
                      <ul class="blog-social">
                        <li>{{ "By: Admin" | translate }}</li>
                        <li>{{ "Payment" | translate }}</li>
                        <li class="digits"><i class="fi fi-rr-clock-nine"></i>15 {{ "min" | translate }}</li>
                      </ul>
                      <hr>
                      <p class="mt-0">{{ "Express checkout is a way to create a convenient checkout experience for your customers. When you create an express checkout link..." | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 xl-50 col-sm-6 box-col-6">
            <div class="card">
              <div class="blog-box blog-grid text-center product-box">
                <div class="product-img"><img class="img-fluid top-radius-blog" src="assets/3.jpg" alt="">
                  <div class="product-hover">
                    <ul>
                      <li><i class="icon-link"></i></li>
                      <li><i class="icon-import"></i></li>
                    </ul>
                  </div>
                </div>
                <div class="blog-details-main">
                  <ul class="blog-social">
                    <li class="digits">9 April 2023</li>
                    <li class="digits">by: Admin</li>
                    <li class="digits">0 Hits</li>
                  </ul>
                  <hr>
                  <h6 class="blog-bottom-details">Perspiciatis unde omnis iste natus error sit.Dummy text</h6>
                </div>
              </div>
            </div>
          </div> -->
    </div>
</div>
<!-- <div class="col-xl-5 xl-40">
  <div class="default-according style-1 faq-accordion job-accordion" id="accordionoc">
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header" aria-controls="collapseExample">
            <h5 class="mb-0">
              <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon"
                aria-expanded="true" aria-controls="collapseicon" (click)="isFindCourse = !isFindCourse"
                [attr.aria-expanded]="!isFindCourse">Find Course <span [className]="!isFindCourse ? 'link-icon chevron down':'link-icon chevron up'"></span></button>  </h5>
              </div>
              <div class="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
                <div class="card-body filter-cards-view animate-chk" [ngbCollapse]="isFindCourse">
                  <div class="job-filter">
                    <div class="faq-form">
                      <input class="form-control" type="text" placeholder="Search.."><i class="search-icon"
                        data-feather="search"></i>
                    </div>
                  </div>
                  <div class="checkbox-animated">
                    <div class="learning-header"><span class="f-w-600 ff-r">Categories</span></div>
                    <label class="d-block" for="chk-ani">
                      <input class="checkbox_animated" id="chk-ani" type="checkbox"> Accounting
                    </label>
                    <label class="d-block" for="chk-ani0">
                      <input class="checkbox_animated" id="chk-ani0" type="checkbox"> Design
                    </label>
                    <label class="d-block" for="chk-ani1">
                      <input class="checkbox_animated" id="chk-ani1" type="checkbox"> Development
                    </label>
                    <label class="d-block" for="chk-ani2">
                      <input class="checkbox_animated" id="chk-ani2" type="checkbox"> Management
                    </label>
                  </div>
                  <div class="checkbox-animated mt-0">
                    <div class="learning-header"><span class="f-w-600 ff-r">Duration</span></div>
                    <label class="d-block" for="chk-ani6">
                      <input class="checkbox_animated" id="chk-ani6" type="checkbox"> 0-50 hours
                    </label>
                    <label class="d-block" for="chk-ani7">
                      <input class="checkbox_animated" id="chk-ani7" type="checkbox"> 50-100 hours
                    </label>
                    <label class="d-block" for="chk-ani8">
                      <input class="checkbox_animated" id="chk-ani8" type="checkbox"> 100+ hours
                    </label>
                  </div>
                  <div class="checkbox-animated mt-0">
                    <div class="learning-header"><span class="f-w-600 ff-r">Price</span></div>
                    <label class="d-block" for="edo-ani">
                      <input class="radio_animated" id="edo-ani" type="radio" name="rdo-ani" checked=""> All Courses
                    </label>
                    <label class="d-block" for="edo-ani1">
                      <input class="radio_animated" id="edo-ani1" type="radio" name="rdo-ani" checked=""> Paid Courses
                    </label>
                    <label class="d-block" for="edo-ani2">
                      <input class="radio_animated" id="edo-ani2" type="radio" name="rdo-ani" checked=""> Free Courses
                    </label>
                  </div>
                  <div class="checkbox-animated mt-0">
                    <div class="learning-header"><span class="f-w-600 ff-r">Status</span></div>
                    <label class="d-block" for="chk-ani3">
                      <input class="checkbox_animated" id="chk-ani3" type="checkbox"> Registration
                    </label>
                    <label class="d-block" for="chk-ani4">
                      <input class="checkbox_animated" id="chk-ani4" type="checkbox"> Progress
                    </label>
                    <label class="d-block" for="chk-ani5">
                      <input class="checkbox_animated" id="chk-ani5" type="checkbox"> Completed
                    </label>
                  </div>
                  <button class="btn btn-view text-center" type="button">Filter</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12">
            <div class="card -20">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon1"
                    aria-expanded="true" aria-controls="collapseicon1" (click)="isCategories = !isCategories"
                    [attr.aria-expanded]="!isCategories">Categories<span [className]="!isCategories ? 'link-icon chevron down':'link-icon chevron up'"></span></button>
                </h5>
              </div>
              <div class="collapse show" id="collapseicon1" aria-labelledby="collapseicon1" data-parent="#accordion">
                <div class="card-body filter-cards-view animate-chk p-0" [ngbCollapse]="isCategories">
                  <div class="categories">
                    <div class="learning-header"><span class="f-w-600 ff-r">Design</span></div>
                    <ul>
                      <li><a href="javascript:void(0)">UI Design </a><span
                          class="badge badge-primary pull-right">28</span></li>
                      <li><a href="javascript:void(0)">UX Design </a><span
                          class="badge badge-primary pull-right">35</span></li>
                      <li><a href="javascript:void(0)">Interface Design </a><span
                          class="badge badge-primary pull-right">17</span></li>
                      <li><a href="javascript:void(0)">User Experience </a><span
                          class="badge badge-primary pull-right">26</span></li>
                    </ul>
                  </div>
                  <div class="categories pt-0">
                    <div class="learning-header"><span class="f-w-600 ff-r">Development</span></div>
                    <ul>
                      <li><a href="javascript:void(0)">Frontend Development</a><span
                          class="badge badge-primary pull-right">48</span></li>
                      <li><a href="javascript:void(0)">Backend Development</a><span
                          class="badge badge-primary pull-right">19</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon2"
                    aria-expanded="true" aria-controls="collapseicon2" (click)="isUpcomingCourses = !isUpcomingCourses"
                    [attr.aria-expanded]="!isUpcomingCourses">Upcoming Courses<span [className]="!isUpcomingCourses ? 'link-icon chevron down':'link-icon chevron up'"></span></button>
                </h5>
              </div>
              <div class="collapse show" id="collapseicon2" aria-labelledby="collapseicon2" data-parent="#accordion">
                <div class="upcoming-course card-body" [ngbCollapse]="isUpcomingCourses">
                  <div class="media pb-3">
                    <div class="media-body"><span class="f-w-600 ff-r">UX Development</span><span class="d-block">Course By
                        <a href="javascript:void(0)"> Lorem ipsum</a></span><span class="d-block"><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star-half-o font-warning"></i></span></div>
                    <div>
                      <h5 class="mb-0 font-primary">18</h5><span class="d-block">Dec</span>
                    </div>
                  </div>
                  <div class="media pb-3">
                    <div class="media-body"><span class="f-w-600 ff-r">Business Analyst</span><span class="d-block">Course By
                        <a href="javascript:void(0)">Lorem ipsum </a></span><span class="d-block"><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star font-warning"></i></span></div>
                    <div>
                      <h5 class="mb-0 font-primary">28</h5><span class="d-block">Dec</span>
                    </div>
                  </div>
                  <div class="media">
                    <div class="media-body"><span class="f-w-600 ff-r">Web Development</span><span class="d-block">Course By
                        <a href="javascript:void(0)">Lorem ipsum </a></span><span class="d-block"><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                          class="fi fi-rr-star-o font-warning"></i></span></div>
                    <div>
                      <h5 class="mb-0 font-primary">5</h5><span class="d-block">Jan</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
</div>
